import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../context/LocaleContext';
import { usePageMeta } from '../hooks/usePageMeta';
import LanguageSwitcher from '../components/LanguageSwitcher';
import './FattiesProjectPage.css';

const FattiesProjectPage: React.FC = () => {
  const { pathFor, t } = useLocale();
  usePageMeta(t('fattiesProject.metaTitle'), t('fattiesProject.metaDescription'));
  return (
    <div className="fatties-project-container">
      <div className="fatties-project-top-bar">
        <Link to={pathFor('')} className="project-back-link">
          <span className="project-back-arrow">←</span>
          <span>{t('common.backToHome')}</span>
        </Link>
        <LanguageSwitcher />
      </div>

      <div className="fatties-project-content">
        <div className="fatties-project-header">
          <h1 className="fatties-project-title">🍩 {t('fattiesProject.title')}</h1>
          <p className="fatties-project-subtitle">
            {t('fattiesProject.subtitle')}
          </p>
        </div>

        <div className="fatties-project-disclaimer">
          <p>{t('fattiesProject.disclaimer')}</p>
        </div>

        <div className="fatties-project-screenshot">
          <img src="/projects/fatties-screenshot.png" alt={t('fattiesProject.screenshotAlt')} className="fatties-screenshot-image" />
        </div>

        <div className="fatties-project-stats">
          <div className="fatties-stat">
            <div className="fatties-stat-number">10,000</div>
            <div className="fatties-stat-label">{t('fattiesProject.totalSupply')}</div>
          </div>
          <div className="fatties-stat">
            <div className="fatties-stat-number">1.2K</div>
            <div className="fatties-stat-label">{t('fattiesProject.twitterFollowers')}</div>
          </div>
          <div className="fatties-stat">
            <div className="fatties-stat-number">850</div>
            <div className="fatties-stat-label">{t('fattiesProject.instagramFollowers')}</div>
          </div>
          <div className="fatties-stat">
            <div className="fatties-stat-number">2022</div>
            <div className="fatties-stat-label">{t('fattiesProject.launchDate')}</div>
          </div>
        </div>

        <div className="fatties-project-description">
          <p>{t('fattiesProject.description')}</p>
        </div>

        <div className="fatties-project-tech">
          <h3 className="fatties-section-title">{t('fattiesProject.builtWith')}</h3>
          <ul className="fatties-tech-list">
            <li>Solidity</li>
            <li>Hardhat</li>
            <li>React</li>
            <li>TypeScript</li>
            <li>Express</li>
            <li>IPFS</li>
            <li>PostgreSQL</li>
            <li>Terraform</li>
            <li>Docker</li>
            <li>Web3</li>
            <li>ERC721A</li>
          </ul>
        </div>

        <div className="fatties-project-links">
          <a
            href="https://opensea.io/collection/fattiesnft"
            target="_blank"
            rel="noopener noreferrer"
            className="fatties-link"
          >
            <span>{t('fattiesProject.openSea')}</span>
            <span className="fatties-link-arrow">↗</span>
          </a>
          <a
            href="https://www.instagram.com/fattiesnft"
            target="_blank"
            rel="noopener noreferrer"
            className="fatties-link"
          >
            <span>{t('fattiesProject.instagram')}</span>
            <span className="fatties-link-arrow">↗</span>
          </a>
          <a
            href="https://twitter.com/fattiesnft"
            target="_blank"
            rel="noopener noreferrer"
            className="fatties-link"
          >
            <span>{t('fattiesProject.twitter')}</span>
            <span className="fatties-link-arrow">↗</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default FattiesProjectPage;

